<template>
    <v-container fluid>
      <v-card elevation="2">
        <v-card-title class="d-flex align-center tableheader white--text">
          <v-icon left color="white">mdi-truck-wrench</v-icon>
          Vendors
          <v-spacer/>
          <v-text-field
              v-model="search"
              label="Search (name / service)"
              prepend-inner-icon="mdi-magnify"
              density="compact"
              variant="solo-filled"
              flat hide-details single-line
              class="me-4"
          />
          <v-btn color="primary" @click="openDialog(null)" v-if="authStore.canEdit">
            <v-icon left>mdi-plus</v-icon> Add Vendor
          </v-btn>
          <!-- <ExportButtons entity="vendors" filename="Vendors" :exclude="['id','created_at','updated_at']"></ExportButtons> -->
          <ExportButtons entity="vendors" filename="Vendors" :headers="headers"></ExportButtons>
        </v-card-title>
  
        <v-data-table :items="filtered" :headers="headers" class="elevation-1">
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip location="top" text="View Details">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="openViewDialog(item)" color="info">
                mdi-eye-outline
              </v-icon>
            </template>
            </v-tooltip>

            <v-tooltip location="top" text="Edit">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="openDialog(item)" color="secondary" v-if="authStore.isAdmin">
                mdi-pencil
              </v-icon>
            </template>
            </v-tooltip>
            
            <v-tooltip location="top" text="Delete">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small @click="deleteItemPrompt(item)" color="error" v-if="authStore.isAdmin">
                mdi-delete
              </v-icon>
            </template>
            </v-tooltip>

          </template>
          <template v-slot:[`no-data`]>
            <v-alert :value="true" color="info" icon="mdi-information-variant" class="ma-3">
              {{ tableLoading ? 'Fetching data...' : 'No vendors available or match your search.' }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
  
      <!-- dialog -->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title>{{ form.id ? 'Edit' : 'Add' }} Vendor</v-card-title>
          <v-form ref="vendorForm" v-model="isFormValid" @submit.prevent="save">
          <v-card-text>
            <v-text-field v-model="form.name" label="Name*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.service_offered" label="Service Offered*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.phone" label="Phone*" variant="outlined" 
            :rules="[rules.required]"
            required/>  

            <v-divider></v-divider>
            <!-- <v-select
              :items="companies"
              item-title="name"
              item-value="id"
              v-model="form.company_id"
              label="Company"
              variant="outlined" class="mb-2" :rules="[rules.required]"
            /> -->
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="dialog=false">Cancel</v-btn>
            <v-btn color="primary" variant="elevated" type="submit" :loading="dialogLoading" :disabled="!isFormValid">Save</v-btn>
            <!-- @click="save" -->
          </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="viewDialog" max-width="800px" @update:modelValue="val => !val && closeViewDialog()">
      <v-card :loading="viewDialogLoading">
        <v-card-title class="tableheader white--text d-flex align-center">
          <!-- <v-icon left color="white" class="mr-2">mdi-truck-wrench</v-icon> -->
          <span class="text-h5">Vendor Details: {{ viewItem?.name }}</span>
          <v-spacer></v-spacer>
          <!-- <v-btn icon="mdi-close" variant="text" color="white" @click="closeViewDialog"></v-btn> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="viewItem" class="pt-4">
          <v-list lines="two" density="compact">
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Name:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.name }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Service Offered:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.service_offered }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Phone:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.phone }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <!-- <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Company:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ findName(companies, viewItem.company_id) }}</v-list-item-text>
            </v-list-item> -->
          </v-list>
        </v-card-text>
        <v-card-text v-else class="text-center py-5">
            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
            <p>Loading vendor details...</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg-grey-lighten-4 pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="tonal" @click="closeViewDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card :loading="dialogLoading">
          <v-card-title class="text-h5">Confirm Deletion</v-card-title>
          <v-card-text>Are you sure you want to delete this vendor: {{ itemToDelete?.name }}?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" text @click="closeDeleteDialog" :disabled="dialogLoading">Cancel</v-btn>
            <v-btn color="red-darken-1" text @click="confirmDelete" :loading="dialogLoading">Delete</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" bottom right>
        {{ snackbar.message }}
        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';
  import VendorService from '@/services/VendorService';
  import { useAuthStore } from '@/stores/auth'; 
  import { useSnackbar } from '@/services/genFunctions';
  import ExportButtons from '@/components/ExportButtons.vue';
  // import CompanyService from '@/services/CompaniesService';

  // const companies = ref([]);
  const { snackbar, showSnackbar } = useSnackbar();
  const authStore = useAuthStore();
  const vendors  = ref([]);
  const search   = ref('');
  const dialog   = ref(false);
  const form     = ref({ id:null, name:'', service_offered:'', phone:''});
  const deleteDialog = ref(false);
  const itemToDelete = ref(null);
  const dialogLoading = ref(false);
  const viewDialog = ref(false);
  const viewItem = ref(null);
  const viewDialogLoading = ref(false);
  const tableLoading = ref(true);
  const vendorForm = ref(null);
  const isFormValid = ref(false);

  const rules = {
    required: value => !!value || 'This field is required.',
  };

  const headers = [
    // { title:'ID', key:'id', sortable:false },
    { title:'Name', key:'name' },
    { title:'Service', key:'service_offered' },
    { title:'Phone', key:'phone' },
    { title:'Actions', key:'actions', sortable:false, width: '150px' }
  ];
  
  // const loadCompanies = async () => companies.value = await CompanyService.getCompanies();
  const load = async () => vendors.value = await VendorService.getVendors();
  
  onMounted(async () => {
    // await loadCompanies();
    await load();
  });
  
  const filtered = computed(() =>
    vendors.value.filter(v =>
      (v.name+v.service_offered).toLowerCase().includes(search.value.toLowerCase())
    )
  );
  
  function openDialog(item) {
    form.value = item ? { ...item } : { id:null, name:'', service_offered:'', phone:'' };
    dialog.value = true;
  }
  async function save() {
    if (!vendorForm.value) return;
    const { valid } = await vendorForm.value.validate();
    if (!valid) {
      showSnackbar('Please correct the form errors.', 'warning');
      return;
    }

    dialogLoading.value = true;
    const { id, ...data } = form.value;
    id ? await VendorService.updateVendor(id, data)
       : await VendorService.createVendor(data);
    dialog.value = false;
    await load();
    dialogLoading.value = false;
    showSnackbar('Vendor saved successfully!', 'success');
  }

  const deleteItemPrompt = (item) => {
    itemToDelete.value = { ...item };
    deleteDialog.value = true;
  };

  const closeDeleteDialog = () => {
    deleteDialog.value = false;
    nextTick(() => itemToDelete.value = null);
    dialogLoading.value = false;
  };

  const confirmDelete = async () => {
    if (!itemToDelete.value?.id) return;
    dialogLoading.value = true;
    try {
        await VendorService.deleteVendor(itemToDelete.value.id);
        vendors.value = vendors.value.filter(v => v.id !== itemToDelete.value.id);
        showSnackbar('Vendor deleted successfully!', 'success');
        closeDeleteDialog();
    } catch (error) {
        const errorMsg = error.response?.data?.error || 'Could not delete vendor.';
        showSnackbar(errorMsg, 'error', 6000);
        console.error("Error deleting vendor:", error.response || error);
    } finally {
        dialogLoading.value = false;
    }
  };

  const openViewDialog = async (item) => {
    viewDialogLoading.value = true;
    viewDialog.value = true;
    viewItem.value = null; 
    try {
      const fullVendorData = await VendorService.getVendor(item.id);
      viewItem.value = fullVendorData;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to load vendor details.';
      showSnackbar(errorMsg, 'error');
      console.error("Error fetching vendor details for view:", error);
      viewDialog.value = false; 
    } finally {
      viewDialogLoading.value = false;
    }
  };

  const closeViewDialog = () => {
    viewDialog.value = false;
    viewItem.value = null;
  };
  
  // function findName(list, id) {
  //   if (!list || !Array.isArray(list) || !id) return '�';
  //   const obj = list.find(i => i && i.id === id);
  //   return obj ? obj.name : `Unknown (ID: ${id})`;
  // }
  </script>
  